import i18n from 'i18next'
import i18nBackend from 'i18next-http-backend'
import i18nLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const options = {
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'lng'
}

const lng = typeof window !== "undefined" ? window.localStorage.msbcc_lng : ''

i18n
  .use(i18nBackend)
  .use(new i18nLanguageDetector(null, { lookupLocalStorage: "msbcc_lng" }))
  .use(initReactI18next)
  .init({
    load: "languageOnly",
    detection: options,
    backend: {
      /* translation file path */
      loadPath: '/languages/{{lng}}.json',
      crossDomain: true
    },
    fallbackLng: "en",
    lng: lng,
    debug: false,

    // we do not use keys in form messages.welcome
    keySeparator: false,

    interpolation: {
      // react already safes from xss
      escapeValue: false
    },
    react: {
      useSuspense: false,
    }
  })


/**
 * Handle translations outside of components
 */

type TranslationFunction = () => void
const callbacks: TranslationFunction[] = []

export const syncTranslation = (func: TranslationFunction) => {
  callbacks.push(func)
  func()
}

function updateTranslations() {
  callbacks.forEach(func => {
    func()
  })
}

// // i18next seems ready -> initial fill translations
// if (i18n.isInitialized) {
//   updateTranslations();
// }

// // we loaded some translation file? reset needed?!?
// // https://www.i18next.com/overview/api#store-events
// i18n.on('loaded', function (lng) {
//   updateTranslations();
// });

const cleanLng = (lng: string) => lng.split("-")[0];

// reset translations to new values on language change
i18n.on('languageChanged', function (lng) {
  const cleaned = cleanLng(lng)
  // Guarded like the read on line 11: this handler fires while i18next
  // initialises, and this module gets pulled into non-browser contexts through
  // @/shared. Without the check the bare localStorage access throws and takes
  // the whole process down — which is what made `jest --runInBand` abort.
  if (typeof window !== 'undefined') window.localStorage.setItem("msbcc_lng", cleaned)

  updateTranslations()
})
